const VALIDATION_URL =
  process.env.STAGE !== 'production' ? 'https://valid-dev.ropto.com/registration' : 'https://valid.ropto.com/registration';

export interface VehicleRegistratonInfo {
  make: string;
  model: string;
  registrationNumber: string;
  numberOfDoors: number;
  bodyStyle: string;
  co2Emissions: number;
  engineCapacity: number;
  fuelType: string;
  colour: string;
  typeApproval: string;
  yearOfManufacture: number;
  dateOfLastV5CIssued: string;
  wheelPlan?: string;
  dateOfFirstRegistration: string;
}

interface VehicleRegistratonResponse {
  success: boolean;
  result: VehicleRegistratonInfo;
}

export function normaliseRegistrationNumber(registrationNumber?: string): string | undefined {
  if (!registrationNumber) {
    return undefined;
  }

  return registrationNumber.replace(/\s/gm, '').toUpperCase();
}

export async function getVehicleRegistrationInfo(registrationNumber?: string): Promise<VehicleRegistratonInfo | undefined> {
  const normalised = normaliseRegistrationNumber(registrationNumber);

  if (!normalised || normalised.length < 3) {
    return undefined;
  }

  try {
    const response = await fetch(`${VALIDATION_URL}/${normalised}`);

    if (!response) {
      console.error('response undefined');
      return undefined;
    }

    if (response.status < 200 || response.status >= 300) {
      console.error('bad response');
      return undefined;
    }

    const data = (await response.json()) as VehicleRegistratonResponse;

    if (data.success) {
      return data.result;
    } else {
      console.error('failed');
    }
  } catch (e) {
    console.error(e);
    return undefined;
  }

  return undefined;
}
